module.exports = __webpack_public_path__ + "img/station-popup.33f1b1b4.png";